/**
* @file 战队-奖励领取
* @author 余凯
*/

import React from 'react'
import { Table, Button, Tag, message } from 'antd';
import './index.less'

import { connect } from 'react-redux'

import Actions from '../../../../apis/team';

@connect(
  state => state.teamReducer,

)
class RewardCollection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      own: 0,
      pageCurrent: 1,
      pageSize: 10,
      pageTotal: 0
    }
  }

  componentDidMount() {
    this.getData()
  }

  getData = async (page) => {
    const params = {

      id: this.props.userInfo.game_team_id,
      game_id: this.props.game,
      page_index: page || this.state.pageCurrent,
      page_size: this.state.pageSize,
    }
    const res = await Actions.getTeamRewardList(params)
    if (res.code == 200) {
      this.setState({
        data: res.data.list,
        pageTotal: res.data.totalNumber
      })
    }
  }

  columns = () => [
    {
      title: '道具名称',
      dataIndex: 'gameteam_reward_name',
      key: 'gameteam_reward_name',
    },
    {
      title: '发放时间',
      dataIndex: 'create_time',
      key: 'create_time',
    },
    {
      title: '操作',
      align: 'center',
      render: (action, record) => (
        <Button
          onClick={() => this.handleReward(record.gameteam_reward_id)}
          type="primary"
          shape="round"
          size="small">
          领取
        </Button>
      )
    },
  ];

  handleChangePage = (page, pageSize) => {
    this.setState({
      pageCurrent: page
    })
    this.getData(page)
  }

  handleReward = async (id) => {
    const params = {

      id: this.props.userInfo.game_team_id,
      game_id: this.props.game,
      gameteam_reward_id: id
    }
    const res = await Actions.putTeamReward(params)
    if (res.code == 200) {
      message.success('领取成功')
      this.getData()
    }
  }

  render() {
    const { data, pageSize, pageCurrent, pageTotal } = this.state
    return (
      <div className="reward_collection" id="reward_collection">
        <h3>奖励领取</h3>
        <Table
          size="small"
          columns={this.columns()}
          dataSource={data}
          pagination={{ pageSize, current: pageCurrent, total: pageTotal, onChange: this.handleChangePage }}
        />
      </div>
    );
  }
}

export default RewardCollection;
